module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (93).b558ac3e.jpg";